// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimFailureInfo = t.struct({
    failureDate: t.maybe(t.Number),
    failurePartNumber: t.String,
    remanIndicator: t.Boolean,
    repairDate: t.maybe(t.Number),
    showRemanIndicator: t.Boolean
}, {
    name: 'ClaimFailureInfo',
    strict: true
});

export const getDefaultState = () => new ClaimFailureInfo({
    failureDate: null,
    failurePartNumber: '',
    remanIndicator: false,
    repairDate: null,
    showRemanIndicator: false
});

export default ClaimFailureInfo;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-failure-info.js